export const listingBookingSettings = {
  section01: {
    title: "الحجوزات المباشرة لهذا الإعلان",
  },
  motor: {
    activeTitle: "محرّك الحجز مُفعّل",
    inactiveTitle: "محرّك الحجز مُعطّل",
    activeDesc: "يمكن للنزلاء حجز هذا الإعلان مباشرةً عبر رابطه.",
    inactiveDesc: "الحجوزات المباشرة مُعطّلة لهذا الإعلان.",
    statusOn: "مُفعّل",
    statusOff: "مُعطّل",
  },
  payment: {
    title: "متى يدفع النزيل؟",
    onArrival: {
      name: "الدفع عند الوصول",
      hint: "احجز مجانًا وادفع عند الوصول.",
    },
    online: {
      name: "الدفع عبر الإنترنت",
      hint: "ادفع عند تأكيد الحجز.",
    },
  },
  common: {
    saving: "جارٍ الحفظ…",
    onlyOnlineBadge: "الدفع عبر الإنترنت فقط",
  },
  hold: {
    title: "مدة الحجز المؤقت",
    desc: "يُحجب التقويم أثناء إتمام النزيل للدفع.<br>إذا لم يدفع خلال المدة المحدّدة، <strong>يُحرَّر التوفّر تلقائيًا</strong>.",
  },
  units: {
    min: "دقيقة",
    hour: "ساعة",
    hours: "ساعات",
  },
  partial: {
    title: "الدفع الجزئي",
    cardTitle: "السماح بدفع جزء فقط عند الحجز",
    descOn: "<strong>مُفعّل.</strong> يمكن للنزيل دفع <strong>{percent}%</strong> الآن ودفع الباقي قبل الوصول (أو دفع المبلغ كاملًا).",
    descOff: "<strong>مُعطّل.</strong> يدفع النزيل <strong>المبلغ كاملًا</strong> عند الحجز.",
    blockTitle: "يُدفع الباقي في مكان الإقامة",
    blockOn: "<strong>مُفعّل.</strong> يدفع النزيل <strong>{percent}% فقط</strong> عبر الإنترنت؛ ويسدّد الباقي <strong>عند الوصول</strong> (لا يمكنه دفع المبلغ كاملًا عبر الإنترنت).",
    blockOff: "<strong>مُعطّل.</strong> يمكن للنزيل اختيار دفع {percent}% أو المبلغ كاملًا عبر الإنترنت.",
  },
  reminder: {
    title: "تذكير بالرصيد المتبقّي",
    cardTitle: "إرسال تذكير بدفع الرصيد المتبقّي",
    daysBefore: "{count} يوم | {count} أيام",
    descOn: "<strong>مُفعّل.</strong> <strong>{daysBefore}</strong> قبل الوصول (حوالي الساعة 09:00 بتوقيت مكان الإقامة) يُرسَل إلى النزيل رابط لدفع الرصيد المتبقّي عبر <strong>واتساب والبريد الإلكتروني</strong>.",
    descOff: "<strong>مُعطّل.</strong> لا يتلقّى النزيل أي تذكير لدفع الرصيد عبر الإنترنت قبل الوصول.",
    daysLabel: "الأيام قبل الوصول",
    hint: "يُرسَل مرة واحدة فقط، وفقط للنزلاء الذين لديهم رصيد متبقٍّ. وإذا كان الباقي يُدفع في مكان الإقامة، فلن يُرسَل.",
  },
  approve: {
    title: "الموافقة على الحجوزات",
    cardTitle: "الموافقة على كل حجز قبل تأكيده",
    descOn: "<strong>مُفعّل.</strong> يبقى كل حجز <strong>بانتظار موافقتك</strong>: يصلك إشعار وتقرّر قبوله أو رفضه. ولا يُؤكَّد حتى توافق عليه.",
    descOff: "<strong>مُعطّل.</strong> تُؤكَّد الحجوزات <strong>تلقائيًا</strong> عند إتمام الدفع. فعّله إذا كنت تفضّل مراجعة كل طلب والموافقة عليه بنفسك.",
  },
  toasts: {
    statusUpdatedAll: "تم تحديث الحالة في جميع الوحدات.",
    statusUpdated: "تم تحديث الحالة.",
    statusError: "تعذّر التحديث.",
    paymentUpdated: "تم تحديث طريقة الدفع.",
    paymentError: "تعذّر حفظ طريقة الدفع.",
    partialUpdated: "تم تحديث الدفع الجزئي.",
    partialError: "تعذّر حفظ الدفع الجزئي.",
    reminderUpdated: "تم تحديث التذكير.",
    reminderError: "تعذّر حفظ التذكير.",
    saved: "تم الحفظ.",
    saveError: "تعذّر الحفظ.",
    linkCopied: "تم نسخ الرابط.",
    copyError: "تعذّر النسخ.",
  },
  share: {
    whatsappText: "مرحبًا 👋 أشاركك رابط الحجز: {link}",
  },
};
